
import React from "react";
import useState from "react";
import i18n from "i18next";
const defaultValue = {
  locale: 'ar',
  setLocale: () => {} 
}

export default React.createContext(defaultValue);
// export function ChangeLocale (l) {
//     debugger;
//     const [locale, setLocale] = useState(i18n.language);
//     if (locale !== l) {
//       i18n.changeLanguage(l);
//     }
//  }

 